export const scrollToEvent = (eventId) => {
  const element = document.getElementById(eventId)
  element?.scrollIntoView({ block: 'nearest', inline: 'nearest' })
}
